import React from "react";
import "../../shared/styles/Global.css";
import "../styles/AccessDenied.css";

const AccessDenied = () => {
  const handleSubscribeClick = () => {
    window.open(
      "https://www.mercadopago.com.ar/subscriptions/checkout?preapproval_plan_id=2c9380849783ce7701979495f6ad062c",
      "_blank"
    );
  };

  const handleContactClick = () => {
    window.open("https://wa.me/5491122450678", "_blank");
  };

  return (
    <div className="accessDeniedContainer fadeIn">
      <div className="accessDeniedBox">
        <h2>Acceso restringido</h2>
        <p>
          Tu período de prueba ha finalizado o tu suscripción no está activa.
        </p>
        <div className="accessDeniedButtons">
          <button className="primaryButton" onClick={handleSubscribeClick}>
            Ir a suscribirme
          </button>
          <button className="secondaryButton" onClick={handleContactClick}>
            Contactar al soporte
          </button>
        </div>
      </div>
    </div>
  );
};

export default AccessDenied;
